import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { teamApi } from '@/api/endpoints/team';
import type { CreateTeamMemberData, UpdateTeamMemberData } from '@/api/endpoints/team';

export const useTeam = (enabled = true) =>
  useQuery({ queryKey: ['team'], queryFn: teamApi.list, staleTime: 1000 * 30, retry: 1, enabled });

export const useTeamRoles = (enabled = true) =>
  useQuery({
    queryKey: ['team-roles'],
    queryFn: teamApi.roles,
    staleTime: 1000 * 60 * 10,
    retry: 1,
    enabled,
  });

export const useCreateTeamMember = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateTeamMemberData) => teamApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['team'] }),
  });
};

export const useUpdateTeamMember = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateTeamMemberData }) =>
      teamApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['team'] }),
  });
};

export const useDeactivateTeamMember = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => teamApi.deactivate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['team'] }),
  });
};
